import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=370162ac&scoped=true"
import script from "./CartView.vue?vue&type=script&lang=js"
export * from "./CartView.vue?vue&type=script&lang=js"
import style0 from "./CartView.vue?vue&type=style&index=0&id=370162ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370162ac",
  null
  
)

export default component.exports